import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import 'moment-timezone';
import { environment } from './environments/environment';
import './polyfills';
import { RootModule } from './root.module';

if ('serviceWorker' in navigator) {
  const hostname = location.hostname.toLowerCase();
  let isFromWebfacing = hostname === environment.WebFacingHost.toLowerCase();

  // The Angular service worker (ngsw-worker.js) is retired: older builds registered it, and it kept
  // serving the previous release from its cache after a deploy. Remove it and its caches on every host.
  navigator.serviceWorker.getRegistrations().then(regs => {
    regs.forEach(reg => {
      const worker = reg.active || reg.waiting || reg.installing;
      if (worker && worker.scriptURL.includes('ngsw-worker.js')) {
        reg.unregister();
      }
    });
  });
  if ('caches' in window) {
    caches.keys().then(names => names.filter(name => name.startsWith('ngsw:')).forEach(name => caches.delete(name)));
  }

  if (!environment.production && !isFromWebfacing) {
    // DEV: register your custom dev-sw
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/dev-sw.js')
        .then(reg => {
          console.log('Dev SW registered:', reg);
        })
        .catch(err => console.error('Dev SW registration failed:', err));
    });
  }
}

if (environment.production) {
  enableProdMode();
}

const bootstrap = () => {
  return platformBrowserDynamic().bootstrapModule(RootModule);
};

/* "Hot Module Replacement" is enabled as described on
 * https://medium.com/@beeman/tutorial-enable-hrm-in-angular-cli-apps-1b0d13b80130#.sa87zkloh
 */
bootstrap(); //Regular bootstrap
